import { boolean, object, optional } from 'valibot';

import { EmailSchema } from './EmailSchema';
import { stringRequired } from './schema.utils';

export const LoginSchema = () =>
  object({
    email: EmailSchema(),
    password: stringRequired(),
    rememberMe: optional(boolean())
  });
